import { render, staticRenderFns } from "./AccettazionePrenotazioniLazioListComponent.vue?vue&type=template&id=4985e732&scoped=true"
import script from "./AccettazionePrenotazioniLazioListComponent.vue?vue&type=script&lang=js"
export * from "./AccettazionePrenotazioniLazioListComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazionePrenotazioniLazioListComponent.vue?vue&type=style&index=0&id=4985e732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985e732",
  null
  
)

export default component.exports